import { Typography } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'
import { COLORS } from '~theme/colors'

export function ElectronicDocumentLabel({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <Typography
      variant="menu"
      sx={[
        {
          backgroundColor: COLORS.greys.light,
          py: 2,
          px: 1.5,
          borderRadius: 2,
          color: COLORS.greys.dark,
          display: 'inline-block',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      Electronic
    </Typography>
  )
}
